import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";
import hexToRGBA from "../../../hexToRGBA";

const slider = ({ palette, spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiSlider"] => ({
	root: {
		marginLeft: "2%",
		width: "95%",
		"&.Mui-disabled": {
			"& .MuiSlider-track": {
				background: palette.coolGrey,
			},
			"& .MuiSlider-markActive": {
				opacity: 1,
				backgroundColor: palette.coolGrey,
			},
			"& .MuiSlider-markLabelActive": {
				color: palette.coolGrey,
			},
		},
		marginTop: spacing(7.25),
	},
	rail: {
		height: spacing(0.5),
		backgroundColor: palette.grey40,
		opacity: 1,
		borderRadius: spacing(0.5),
	},
	track: {
		height: spacing(0.5),
		backgroundColor: palette.lightPrimary,
		border: "none",
		transition: "none",
	},
	thumb: {
		width: spacing(2.5),
		height: spacing(2.5),
		borderRadius: "50%",
		marginTop: "-0.8rem",
		marginLeft: "-0.8rem",
		background: `linear-gradient(135deg, ${palette.lightPrimary} 0%, ${palette.primary} 100%)`,
		transition: "box-shadow, width, height, margin",
		transitionDuration: "150ms",
		margin: "0px",
		"&:hover, &.Mui-focusVisible, &.Mui-active": {
			width: spacing(3),
			height: spacing(3),
			boxShadow: `
				0 1.2rem 1.9rem ${hexToRGBA(palette.primary, 0.25)},
				0 0.5rem 0.8rem ${hexToRGBA(palette.primary, 0.16)},
				0 0.26rem 0.42rem ${hexToRGBA(palette.primary, 0.12)}
			`,
		},
		"&.Mui-disabled": {
			width: spacing(2.5),
			height: spacing(2.5),
			borderRadius: spacing(2.5),
			background: palette.coolGrey,
			"& .MuiSlider-valueLabel": {
				"& *": {
					color: palette.grey30,
				},
			},
		},
	},
	mark: {
		width: spacing(2),
		height: spacing(2),
		borderRadius: "50%",
		borderColor: palette.white,
		backgroundColor: palette.grey40,
		borderWidth: spacing(0.625),
		borderStyle: "solid",
		transform: "translateX(-50%)",
		opacity: 1,
		top: spacing(0.875),
		"&.MuiSlider-markActive": {
			opacity: 1,
			backgroundColor: palette.lightPrimary,
		},
	},
	markLabel: {
		top: spacing(4.375),
		fontSize: "1.2rem",
		fontFamily: "RoobertCEZ",
		letterSpacing: "0.04em",
		textAlign: "center",
		textTransform: "uppercase",
		fontWeight: 600,
		color: palette.grey30,
		lineHeight: spacing(2),
		"&.MuiSlider-markActive": {
			color: palette.primary,
		},
	},
	valueLabel: {
		top: "calc(50% - 3.2rem)",
		left: "auto",
		background: "none",
		"& *": {
			background: "transparent",
			fontFamily: "RoobertCEZ",
			letterSpacing: "0.04em",
			textAlign: "center",
			textTransform: "uppercase",
			fontWeight: 600,
			color: palette.primary,
			lineHeight: spacing(2),
			fontSize: "1.2rem",
		},
	},
});

export default slider;
